function combineDateAndTime(date, time) {
  if (!date || !time) return "";

  const formattedDate =
    date instanceof Date ? date.toISOString().split("T")[0] : date;
  const [hours, minutes] = time.split(":").map(Number);
  const dateParts = formattedDate.split("-").map(Number);

  const utcDateTime = new Date(
    Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2], hours, minutes)
  );

  return utcDateTime.toISOString();
}

export { combineDateAndTime };
